const firebaseConfig = {
    apiKey: "AIzaSyDxDlHc70Sspm_AVzCVy053CR_F4t2o2S4",
    authDomain: "life-motion-clinic.firebaseapp.com",
    projectId: "life-motion-clinic",
    storageBucket: "life-motion-clinic.appspot.com",
    messagingSenderId: "21890305045",
    appId: "1:21890305045:web:35d0b90d3a278989b0d21c"
};
export default firebaseConfig;
